export default function convertToDomNode(text) {
    const t = document.createElement("template");
    t.innerHTML = text;
    return t.content.firstElementChild;
}
